export default class NamedError extends Error {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
  }
}



// WEBPACK FOOTER //
// ../iron/common/report/queries/utils/named-error.js